import "./../../styles/Account.css";

import Container from "../../components/Layout/Container";

import Input, { onEnter } from "../../components/TextField/Input";
import { Button } from "../../components/Button/Button";
import { useState } from "react";
import {
  handleVerificationCode,
  handlePhone,
  isBlankStr,
  validateEmail,
  validatePhone,
} from "../../hooks/useValidate";
import { openAlert } from "../../components/Modal/MsgBox";

export default function FindLoginId() {
  const pageName = "아이디 찾기";
  const [userInfo, setUserInfo] = useState({
    name: "",
    phone: "",
    company: "",
    email: "",
    verificationCode: "",
  });
  const [userLoginId, setUserLoginId] = useState("");
  const [sendVerifyCode, setSendVerifyCode] = useState(false);
  const [findSuccess, setFindSuccess] = useState(false);

  const onChangeUserInfo = (e) => {
    const { name, value } = e.target;
    let save;
    if (name === "verificationCode") {
      save = handleVerificationCode(value);
    } else if (name === "phone") {
      save = handlePhone(value);
    } else {
      save = value;
    }

    if (name !== "verificationCode") {
      setSendVerifyCode(false);
      setFindSuccess(false);
      setUserLoginId("");
    }

    setUserInfo({
      ...userInfo,
      [name]: save,
      ...(name !== "verificationCode" ? { verificationCode: "" } : {}),
    });
  };

  const onKeyDown = (e) => {
    onEnter(e, submit);
  };

  const validateAccountInfo = () => {
    if (isBlankStr(userInfo.name)) {
      openAlert("이름이 입력되지 않았습니다.");
      return false;
    }
    if (!validatePhone(userInfo.phone)) return false;
    if (isBlankStr(userInfo.company)) {
      openAlert("소속을 입력해주세요.");
      return false;
    }
    return validateEmail(userInfo.email);
  };

  const validateInput = () => {
    if (!validateAccountInfo()) return false;
    if (!sendVerifyCode) {
      openAlert("인증번호 요청이 필요합니다.");
      return false;
    }
    if (isBlankStr(userInfo.verificationCode)) {
      openAlert("인증번호가 입력되지 않았습니다.");
      return false;
    }
    return true;
  };

  function sendEmailVerifyCode() {
    setFindSuccess(false);
    setUserLoginId("");

    if (!validateAccountInfo()) return;

    setSendVerifyCode(false);
    fetch("/api-tlo/emailVerification/send/findid", {
      method: "POST",
      headers: { "Content-Type": "application/json; charset=UTF-8" },
      body: JSON.stringify({
        name: userInfo.name,
        phone: userInfo.phone.replace(/-/g, ""),
        company: userInfo.company,
        email: userInfo.email,
      }),
    })
      .then(async (res) => {
        if (res.status === 200 || res.status === 201) {
          setSendVerifyCode(true);
          openAlert("인증번호를 전송 했습니다.");
          return;
        }
        if (res.status === 400) {
          const json = await res.json();
          throw new Error(json.message || "인증번호를 전송 할 수 없습니다.");
        }
        throw new Error("인증번호를 전송 할 수 없습니다.");
      })
      .catch((error) => {
        openAlert(error.message);
      });
  }

  function submit() {
    if (!validateInput()) return;

    fetch("/api-tlo/emailVerification/check/findid", {
      method: "POST",
      headers: { "Content-Type": "application/json; charset=UTF-8" },
      body: JSON.stringify({
        ...userInfo,
        phone: userInfo.phone.replace(/-/g, ""),
      }),
    })
      .then(async (res) => {
        if (res.status === 200) {
          const json = await res.json();
          setFindSuccess(true);
          setUserLoginId(json.loginId);
          openAlert("인증에 성공 했습니다.");
          return;
        }
        if (res.status === 400) {
          const json = await res.json();
          throw new Error(json.message || "인증을 완료할 수 없습니다.");
        }
        throw new Error("인증을 완료할 수 없습니다.");
      })
      .catch((error) => openAlert(error.message));
  }

  return (
    <main id="account-page-wrap">
      <h1 className="sr-only">{`${pageName} 페이지`}</h1>

      <Container>
        <div className="page-content login-page">
          <div className="gs-account-form">
            <h1 className="top">{pageName}</h1>
            <p className="gs-bullet fc-cerulean-blue">
              회원가입 시 등록한 이름, 휴대폰 번호, 소속을 입력해주세요.
              <br />
              이메일에는 인증번호를 받을 주소를 입력해주세요.
            </p>
            <div>
              <Input.Group>
                <Input
                  id="user-name"
                  type="text"
                  label="이름을 입력해주세요."
                  placeholder="이름 입력"
                  name="name"
                  value={userInfo.name}
                  onChange={onChangeUserInfo}
                  onKeyDown={onKeyDown}
                  maxLength={20}
                />
                <Input
                  id="phone"
                  type="tel"
                  label="휴대폰 번호를 입력해주세요."
                  placeholder="휴대폰 번호 입력"
                  name="phone"
                  value={userInfo.phone}
                  onChange={onChangeUserInfo}
                  onKeyDown={onKeyDown}
                  maxLength={13}
                />
                <Input
                  id="company"
                  type="text"
                  label="소속을 입력해주세요."
                  placeholder="소속 입력"
                  name="company"
                  value={userInfo.company}
                  onChange={onChangeUserInfo}
                  onKeyDown={onKeyDown}
                  maxLength={30}
                />
                <Input
                  id="email"
                  type="email"
                  label="인증번호를 받을 이메일을 입력해주세요."
                  placeholder="인증번호 수신 이메일 입력"
                  maxLength={100}
                  name="email"
                  value={userInfo.email}
                  onChange={onChangeUserInfo}
                  onKeyDown={onKeyDown}
                />

                <div className="gs-input-box flex">
                  <Input
                    id="authentication-num"
                    type="tel"
                    label="인증번호를 입력해주세요."
                    placeholder="인증번호 입력"
                    maxLength={6}
                    name="verificationCode"
                    value={userInfo.verificationCode}
                    onChange={onChangeUserInfo}
                    onKeyDown={onKeyDown}
                  />
                  <Button
                    type="button"
                    className="full silver"
                    onClick={sendEmailVerifyCode}
                  >
                    인증번호 요청
                  </Button>
                </div>
              </Input.Group>
              <div className="gs-bottom-btns col">
                <Button className="submit" onClick={submit}>
                  <strong>확 인</strong>
                </Button>
              </div>
              {findSuccess && userLoginId !== undefined && (
                <div className="gs-box bt">
                  <div>
                    회원님의 아이디는{" "}
                    <strong className="fc-cerulean-blue">{userLoginId}</strong>{" "}
                    입니다.
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Container>
    </main>
  );
}
